import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import IntlMessage from "../helpers/IntlMessages";
import { API_GET_AVAILABILITY, gAPI_PROPERTIES } from "../../constants/api";

const styles = ` <style>
        table {
            width: 100%;
            border-collapse: collapse;
        }
      
        img {
            width: 150px;
            height: 100px;
        }
    </style>`;
const ARI = ({ gid, pid, integration, checkInDate, checkOutDate, corporateCode, handleManage }) => {
  const [startDate, setStartDate] = useState(checkInDate || moment().add("days", 1).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(checkOutDate || moment().add("days", 2).format("YYYY-MM-DD"));
  const [adults, setAdults] = useState(1);
  const [childrens, setChildrens] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [code, setCode] = useState(corporateCode || "");
  const [hideDiv, setHideDiv] = useState(true);
  const [loading, setLoading] = useState(false);
  const [roomData, setRoomData] = useState([]);
  const [selectedRoomData, setSelectedRoomData] = useState([]);
  const [roomsList, setRoomsList] = useState();
  const [showForm, setShowForm] = useState(true);
  useEffect(() => {
    fetch(gAPI_PROPERTIES + `/${pid}/rooms`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        setRoomsList(json?.rooms || []);
      });
  },[pid]);

   const calculatePrice = (price) => {
    let diff = moment(endDate).diff(moment(startDate), "days");
    return Math.round((price / diff) * 100) / 100;
  };


  const handleAvailability = () => {
    setShowForm(false);
    setLoading(true);
    let rmsPropertyId = '';
    if (integration?.Channel === 'Sabre') rmsPropertyId = pid;
    fetch(
      API_GET_AVAILABILITY +
      `/${integration?.Id}?group_id=` +
      gid +
      "&adults=" +
      adults +
      "&children=" +
      childrens +
      "&dateIn=" +
      moment(startDate).format("YYYY-MM-DD") +
      "&dateOut=" +
      moment(endDate).format("YYYY-MM-DD") +
      "&rooms=" +
      rooms +
      "&channel=" +
      integration?.Channel +
      "&promoCode=" +
      code + "&propertyId=" + rmsPropertyId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.roomTypes !== undefined && json.roomTypes.length > 0) {
          setLoading(false);
          json.roomTypes.map((m) => {
            let image = "";
            if (roomsList !== undefined && roomsList.length > 0) {
              image =
                roomsList.filter(
                  (f) =>
                    (f?.provider === integration?.Channel || f?.provider === "RMS") && f?.providerRoomCode == m?.roomTypeCode
                )[0]?.images[0]?.url ?? "";
            }
            m.roomImage = image === "" ? m.roomImage : image;
          });
          setRoomData(json.roomTypes);
        }
      })
      .catch((err) => (false));
  };
  // useEffect(() => {
  //   if(roomsList !== undefined)
  //       handleAvailability();
  // }, [roomsList, adults, rooms, childrens]);

  const toggle = () => setHideDiv(!hideDiv);

  const handleStartDate = (e) => setStartDate(e.target.value);

  const handleEndDate = (e) => setEndDate(e.target.value);

  const handleAdults = (e) => setAdults(e.target.value);

  const handleChildrens = (e) => setChildrens(e.target.value);

  const handleRooms = (e) => setRooms(e.target.value);

  const handleSelect = (roomTypeCode) => {
    let lst = [...selectedRoomData];
    if (lst.includes(roomTypeCode) === true) setSelectedRoomData(lst.filter((f) => f !== roomTypeCode));
    else {
      lst.push(roomTypeCode);
      setSelectedRoomData(lst);
    }
  };

  const showTemplatePreview = (index, roomName, price, ratePlan, roomImage, roomTypeCode) => {
    let text = ``;
    text = text.replace("{roomImage}", roomImage);
    text = text.replace("{ratePlan}", ratePlan);
    text = text.replace("{price}", price);
    text = text.replace("{roomName}", roomName);
    return (
      <Fragment>
        <tr>
          <td style={{ border: "1px solid black", verticalAlign: "top" }}>
            <table>
              <tr>
                <td>
                  <img
                    src={roomImage && roomImage !== "" ? roomImage : "https://placehold.jp/150x150.png"}
                    alt="Room 1"
                    style={{ width: "150px", height: "auto" }}
                  />
                </td>
                <td style={{ padding: "5px 10px" }}>
                  <div
                    className="row"
                    style={{ position: "absolute", right: "20px", marginTop: "-5px", cursor: "pointer" }}
                  >
                    <svg
                      onClick={() => handleSelect(roomTypeCode)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={25}
                      height={25}
                      style={{ fill: `${selectedRoomData.includes(roomTypeCode) ? "lightgreen" : "white"}` }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                      />
                    </svg>
                  </div>
                  <h6 style={{ margin: 0, color: "#333" }}><b>{roomName}</b></h6>
                  {/* <p style={{ margin: "5px 0", fontSize: "16px", color: "#555" }}>
                    Price: <b>{price}</b>/night
                  </p> */}
                  <p style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
                     {ratePlan} : {calculatePrice(price)}/night
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </Fragment>
    );
  };

  const handleReply = async () => {
    let lst = `<p>Here are the available rates for ${adults} adults and ${childrens} children from ${startDate} to ${endDate}.</p> <hr/><table style='min-width: 500px'>`;
    selectedRoomData.map((m) => {
      let obj = roomData.filter((r) => r.roomTypeCode === m)[0];
      lst += `<tr><td style='border: 1px solid black;verticalAlign: top'><table><tr><td>
            <img src=${obj.roomImage && obj.roomImage !== "" ? obj.roomImage : "https://placehold.jp/150x150.png"} alt='' style='width: 150px; height: auto'/>
            </td><td style='padding:5px 10px'>                            
            <h5 style='margin: 0, color: '#333'}}><b>${obj.roomTypeName}</b></h5>
            <p style='margin: 5px 0; fontSize: 14px; color: #555'>${obj?.minimumRate?.ratePlanName} : ${calculatePrice(obj?.minimumRate?.price)}/night</p>
            </td></tr></table></td></tr>`;
    });
    lst += "</table>";
    await Office.context.mailbox.item.displayReplyAllFormAsync(lst);
  };
  return (
    <Fragment>
      <div className="header-clear-small" style={{ overflowY: "scroll", paddingBottom: "8rem" }}>
        <div className="mb-2">
          <a href="#" onClick={(e) => {
            e.preventDefault();
            if (showForm) {
              handleManage("page", "main");
            } else {
              setShowForm(true);
              setLoading(false);
            }
          }}
            className=" mb-2 ml-3" style={{ float: "left" }}>
            <span className="color-dark-dark">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-arrow-left-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                />
              </svg>{" "}
            </span>
          </a>
        </div>
        {showForm && (
          <div className="row mt-2 mb-3 form-search " style={{ margin: "10px", borderRadius: "4px" }}>
            <div className="col-12 ">
              <label className="mb-1 font-11"><IntlMessage id= "main.check_in" /></label>
              <input
                type="date"
                onChange={handleStartDate}
                value={startDate}
                className="form-control"
                id="startDate"
                min={moment().format("YYYY-MM-DD")}
              />
            </div>

            <div className="col-12 ">
              <label className="mb-1 font-11"><IntlMessage id= "main.check_out" /></label>
              <input
                type="date"
                onChange={handleEndDate}
                value={endDate}
                className="form-control"
                id="endDate"
                min={moment().format("YYYY-MM-DD")}
              />
            </div>
            <div className="col-12 ">
              <label className="mb-1 font-11">Code</label>
              <input
                type="text"
                onChange={(e) => setCode(e.target.value)}
                value={code}
                className="form-control"
                id="code"
              />
            </div>
            {/* {roomData.length > 0 && ( */}
            <div className="col-12 " >
              <div className="">
                <label className="mb-1 font-11"><IntlMessage id= "main.rooms" /></label>
                <div className="">
                  <input
                    type="number"
                    min={1}
                    value={rooms}
                    onChange={handleRooms}
                    className="form-control"
                    id="rooms"
                  />
                </div>
              </div>
              <div className="">
                <label className="mb-1 font-11"><IntlMessage id= "main.adults" /></label>
                <div className="">
                  <input
                    type="number"
                    min={1}
                    value={adults}
                    onChange={handleAdults}
                    className="form-control"
                    id="adults"
                  />
                </div>
              </div>
              <div className="">
                <label className="mb-1 font-11"><IntlMessage id="main.children" /></label>
                <div className="">
                  <input
                    type="number"
                    min={0}
                    value={childrens}
                    onChange={handleChildrens}
                    className="form-control"
                    id="childrens"
                  />
                </div>
              </div>
              {/* <div className="col-12 mb-0">
                    <button onClick={toggle} className="ari-filter-close">
                      Close
                    </button>
                  </div> */}
            </div>
            {/* )} */}
            <div className="col-12 border-left mt-4 mb-4">
              <button
                type="submit"
                onClick={handleAvailability}
                className="btn-full btn border-green-dark reply-button"
                style={{ padding: "6px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
                <span className="ml-1"><IntlMessage id="main.search" /></span>
              </button>
            </div>
          </div>
        )}

        <div className="col-12">
          {/* {roomData.map(m =>
                    // <div className="card card-style">
                    //     <div className="row">
                    //         <div className="col-6 px-0">
                    //             <img src={m?.roomTypeImage && m?.roomTypeImage !== "" ? m.roomTypeImage : "https://placehold.jp/150x150.png"} style={{ height: '170px', width: '100%', objectFit: 'cover' }}></img>
                    //         </div>
                    //         <div className="col-6 pl-1">
                    //             <div
                    //                 className="position-absolute availability-badge"
                    //                 style={{ color: `${m?.available === true ? 'sky-blue ' : 'gray'}` }}
                    //             >
                    //                 {m.available === true ? 'Available' : 'Not Available'}
                    //             </div>
                    //             <div className="mt-3">
                    //                 <p className="mb-3" style={{ 'color': 'black' }}>
                    //                     {m?.roomTypeName}
                    //                 </p>

                    //                 <div className="form-custom form-label form-icon mb-3">
                    //                     <i className="bi bi-check-circle font-13"></i>
                    //                     <select className="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                    //                         <option selected></option>
                    //                         <option value="1">Bootstrap 5</option>
                    //                         <option value="2">Vanilla JavaScript</option>
                    //                         <option value="3">Latest Web Technologies</option>
                    //                     </select>
                    //                     <label for="c1" className="color-theme">Select an Option</label>
                    //                     <div className="valid-feedback">HTML5 does not offer Dates Field Validation!</div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </div>
                    // </div>
                    <tr>
                        <td style={{ width: '150px', padding: '10px', border: '1px solid #ddd' }}>
                            <img src='{roomImage}' alt='Room 1' style={{ width: '100%', height: 'auto', bordeeRadius: '8px' }}></img>
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd', verticalAlign: 'top' }}>
                            <h3 style='margin: 0; color: #333;'>{roomName}</h3>
                            <p style='margin: 5px 0; font-size: 16px; color: #555;'>Price: {price} / night</p>
                            <p style='margin: 5px 0; font-size: 14px; color: #777;'>Rateplan: {ratePlan}</p>
                        </td>
                    </tr>
                )} */}
          <style>{styles}</style>
          {loading ? (
            <div id="ari-rooms-loader" className="preloader-show col-12">
              <div
                className="spinner-border color-highlight-myma"
                role="status"
                style={{ height: "1.5rem", width: "1.5rem" }}
              ></div>
            </div>
          ) : (
            <Fragment>
              {roomData !== undefined && roomData.length > 0 && (
                <Fragment>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "separate",
                      borderSpacing: "10px",
                    }}
                  >
                    {roomData.map((d, index) => (
                      <Fragment>
                        {showTemplatePreview(
                          index,
                          d.roomTypeName,
                          d?.minimumRate?.price,
                          d?.minimumRate?.ratePlanName,
                          d.roomImage,
                          d.roomTypeCode
                        )}
                      </Fragment>
                    ))}
                  </table>
                </Fragment>
              )}
            </Fragment>
          )}
          {/* 
                <div className="card card-style">
                    <div className="row">
                        <div className="col-6">
                            <img src={"https://placehold.jp/150x150.png"} style={{ height: '170px', width: '100%', objectFit: 'cover' }}></img>
                        </div>
                        <div className="col-6">
                            <div className="content mt-2">
                                <p className="mb-3">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque gravida aliquam.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-style">
                    <div className="row">
                        <div className="col-6">
                            <img src={"https://placehold.jp/150x150.png"} style={{ height: '170px', width: '100%', objectFit: 'cover' }}></img>
                        </div>
                        <div className="col-6">
                            <div className="content mt-2">
                                <p className="mb-3">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque gravida aliquam.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-style">
                    <div className="row">
                        <div className="col-6">
                            <img src={"https://placehold.jp/150x150.png"} style={{ height: '170px', width: '100%', objectFit: 'cover' }}></img>
                        </div>
                        <div className="col-6">
                            <div className="content mt-2">
                                <p className="mb-3">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque gravida aliquam.
                                </p>
                            </div>
                        </div>
                    </div>
                </div> */}
        </div>
        <Fragment>
          {selectedRoomData.length > 0 && (
            <div id="footer-bar" className="footer-bar footer-bar-detached ari-footer">
              <div style={{ width: "100%" }}>
                <div className="col-12 text-center mb-2">
                  <button
                    type="submit"
                    onClick={handleReply}
                    className="btn-full btn border-green-dark reply-button"
                    style={{ padding: "8px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={15}
                      height={15}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                      />
                    </svg>
                    <span className="ml-1"><IntlMessage id="main.pastetooutlook" /></span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </Fragment>
      </div>
    </Fragment>
  );
};

export default ARI;
